import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { Accordion, Text } from '@beef/ui-kit';
import { AccordionModel } from './components/AccordionModel';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const FAQ = ({ title, questions }) => (
  <div className={cn('panel')}>
    {title && (
    <div className={cn('title')}>
      <Text size="size3-b">{title}</Text>
    </div>
    )}
    {!!questions.length && (
    <Accordion
      items={questions}
      panelContent={AccordionModel}
      size="size4-m"
    />
    )}
  </div>
);

FAQ.propTypes = {
  title: PropTypes.string,
  questions: PropTypes.arrayOf({
    title: PropTypes.string,
    content: PropTypes.objectOf({
      description: PropTypes.string,
    }),
  }),
};

export default FAQ;
